module.exports = __webpack_public_path__ + "static/img/1.1c7f78a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/1.png
// module id = Hvmv
// module chunks = 1